import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=03ca1c00&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=ts"
export * from "./PriceBox.vue?vue&type=script&lang=ts"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=03ca1c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca1c00",
  null
  
)

export default component.exports